module.exports = __webpack_public_path__ + "img/hair_rituel-logo_white.a0b61dab.svg";